const normalizeSearchValue = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const splitSearchTokens = (value) => normalizeSearchValue(value)
  .split(/[^\p{L}\p{N}]+/u)
  .filter(Boolean);

const getFieldSearchScore = (value, query) => {
  const normalizedValue = normalizeSearchValue(value);
  const normalizedQuery = normalizeSearchValue(query);

  const compactValue = normalizedValue.replace(/\s+/g, '');
  const compactQuery = normalizedQuery.replace(/\s+/g, '');

  if (!compactQuery || !compactValue.includes(compactQuery)) {
    return Number.POSITIVE_INFINITY;
  }

  if (compactValue === compactQuery) {
    return 0;
  }

  const tokens = splitSearchTokens(normalizedValue);

  if (tokens.includes(normalizedQuery)) {
    return 1;
  }

  if (tokens.some(token => token.startsWith(normalizedQuery))) {
    return 2;
  }

  if (normalizedValue.startsWith(normalizedQuery)) {
    return 3;
  }

  return 4 + normalizedValue.indexOf(normalizedQuery) / 1000 + normalizedValue.length / 100000;
};

const getFlashcardSearchScore = (card, query) => {
  const fieldScores = [
    getFieldSearchScore(card.nativeText, query),
    getFieldSearchScore(card.studyTextPrimary, query),
    getFieldSearchScore(card.studyTextSecondary, query),
  ];

  return Math.min(...fieldScores);
};

const getSearchRankedFlashcards = (flashcards, query) => {
  const normalizedQuery = normalizeSearchValue(query).trim();

  if (!normalizedQuery) {
    return flashcards.map((card, index) => ({ card, searchScore: Number.POSITIVE_INFINITY, originalIndex: index }));
  }

  return flashcards
    .map((card, index) => ({ card, searchScore: getFlashcardSearchScore(card, normalizedQuery), originalIndex: index }))
    .filter(({ searchScore }) => Number.isFinite(searchScore))
    .sort((a, b) => {
      if (a.searchScore !== b.searchScore) {
        return a.searchScore - b.searchScore;
      }
      return a.originalIndex - b.originalIndex;
    });
};

const buildStudyCopyText = (card) => [card.studyTextPrimary, card.studyTextSecondary].filter(Boolean).join('\n');

module.exports = {
  normalizeSearchValue,
  getFieldSearchScore,
  getFlashcardSearchScore,
  getSearchRankedFlashcards,
  buildStudyCopyText,
};
